import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  @Output() fire: EventEmitter<any> = new EventEmitter();
  @Output() search: EventEmitter<any> = new EventEmitter();
  @Output() dataChangeObserver: EventEmitter<any> = new EventEmitter();
  private message: BehaviorSubject<string> = new BehaviorSubject<string>('')

  constructor() {}

  getEmittedValue() {
    return this.fire;
  }

  changeData(data) {
    this.fire.emit(data);
  }

  getSearchData() {
    return this.search;
  }

  setSearchData(data) {
    this.search.emit(data);
  }

  initSearchData() {
    this.search.emit({
      theme: [],
      categorie: [],
      search: '',
      dateDu: '',
      dateAu: ''
    });
  }

  getMessage() {
    return this.message;
  }

  setMessage(mes: string) {
    this.message.next(mes);
  }
}
